import SubscriptionPlanCard from './SubscriptionPlanCard'

export default SubscriptionPlanCard
